module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-app-container"
  }, [_c('div', {
    class: {
      'pp-app': 1,
      'pp-app--popup-open': _vm.showSubscribePopup
    }
  }, [_c('div', {
    staticClass: "pp-main"
  }, [_c('pp-sidebar', {
    attrs: {
      "account": _vm.account
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pp-page-container"
  }, [_c('div', {
    staticClass: "pp-navbar"
  }, [_c('nav-bar-search')], 1), _vm._v(" "), _c('div', {
    staticClass: "pp-page",
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('router-view')], 1)])], 1), _vm._v(" "), _c('pp-playbar', {
    attrs: {
      "enable-flac": _vm.flacSupported,
      "enable-flac-track": _vm.flacSupportedTrack,
      "playing": _vm.playback.playing,
      "playback-position": _vm.playback.position,
      "playback-position-seconds": _vm.playback.positionSeconds,
      "playback-duration": _vm.playback.duration,
      "current-track": _vm.playback.track,
      "queue": _vm.queue,
      "history": _vm.history
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'pp-popup': 1,
      'pp-popup--visible': _vm.showSubscribePopup
    }
  }, [_c('div', {
    staticClass: "pp-popup__box"
  }, [_c('div', {
    staticClass: "pp-popup__title"
  }, [_vm._v("\n                    You've run out of free plays\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "pp-popup__message"
  }, [_c('p', [_vm._v("\n                        We hope you've enjoyed trialing our new and improved classical streaming service.\n                    ")]), _vm._v(" "), (!_vm.$root.isIos) ? _c('p', [_vm._v("\n                        To get access to "), _c('strong', [_vm._v("1000+ albums")]), _vm._v(" and "), _c('strong', [_vm._v("8000+ tracks")]), _vm._v(" by "), _c('strong', [_vm._v("300+ composers")]), _vm._v(", please subscribe.\n                    ")]) : _vm._e()]), _vm._v(" "), (!_vm.$root.isIos) ? _c('a', {
    staticClass: "pp-popup__button",
    attrs: {
      "href": "https://www.pristineclassical.com/pages/player-subscribe"
    }
  }, [_vm._v("\n                    Subscribe now\n                ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "pp-popup__button pp-popup__button--secondary",
    on: {
      "click": function($event) {
        _vm.showSubscribePopup = false
      }
    }
  }, [_vm._v("\n                    Continue exploring\n                ")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15b24db8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Root.vue
// module id = 171
// module chunks = 1